export default __webpack_public_path__ + "static/media/bg-logo.a852abb8.png";